export const generatePersonSchema = (persons) => {
    if (!persons || persons.length === 0) return null;

    return {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "Public Figures Karma Ranking",
        "description": "A comprehensive ranking of public figures based on their karma scores voted by users worldwide.",
        "numberOfItems": persons.length,
        "itemListElement": persons.slice(0, 50).map((person, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
                "@type": "Person",
                "name": person.name,
                "jobTitle": person.occupation || undefined,
                "image": person.image || undefined,
                "description": person.achievements || undefined,
                ...(person.birthplace && {
                    "birthPlace": {
                        "@type": "Place",
                        "name": person.birthplace
                    }
                }),
                ...(person.dob && { "birthDate": person.dob }),
                ...(person.net_worth && {
                    "netWorth": {
                        "@type": "MonetaryAmount",
                        "value": person.net_worth,
                        "currency": "USD"
                    }
                })
            }
        }))
    };
};

export const generateWebsiteSchema = () => {
    return {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Karma Rankings",
        "url": "https://www.karmaranking.com",
        "description": "Vote on public figures and see who deserves good or bad karma. A community-driven ranking platform.",
        "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.karmaranking.com/?search={search_term_string}",
            "query-input": "required name=search_term_string"
        }
    };
};

export const generateOrganizationSchema = () => {
    return {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Karma Rankings",
        "url": "https://www.karmaranking.com",
        "logo": "https://www.karmaranking.com/logo512.png",
        "sameAs": []
    };
};
